import React from 'react'
import herobg from '../../../assets/TMBanner.png'
import MobileHeroBg from '../../../assets/TMBanner.png'
import COLORS from '../../../constants/colors.js'

const TransvaginalOne = () => {
  return (
    <>
      {/* Desktop/Laptop/Tablet Hero Section */}
      <section className="hidden sm:flex relative w-full min-h-[45vh] md:min-h-[47vh] lg:min-h-[75vh] xl:min-h-[75vh]  items-center justify-center overflow-hidden">
        {/* Background Image */}
        <img
          src={herobg}
          alt="Hero Background"
          className="absolute inset-0 w-full h-full object-cover z-0"
        />

        {/* Overlay for better text visibility */}
        <div className="absolute inset-0  z-10" />

        {/* Content */}
        <div className="relative z-20 flex flex-col items-center justify-center w-full px-6 md:px-16 lg:px-24 py-8 text-center">
          <h1
            className="text-2xl md:text-3xl lg:text-5xl font-bold mb-4 drop-shadow-lg"
            style={{ fontFamily: 'Quicksand, sans-serif', color: COLORS.white }}
          >
Suffered Complications After a Transvaginal Mesh Implant?          </h1>
          <h2
            className="text-sm sm:text-base md:text-xs lg:text-xl mb-6 font-medium drop-shadow leading-relaxed"
            style={{ fontFamily: 'Quicksand, sans-serif', color: COLORS.white }}
          >
Thousands of women have reported chronic pain, erosion, and multiple revision surgeries after mesh implants. You may be eligible for legal settlement.          </h2>
        </div>
      </section>
{/* Mobile Hero Section */}
<section className="flex sm:hidden relative w-full min-h-[90vh] items-center justify-center overflow-hidden">
  {/* Background Image */}
  <img
    src={MobileHeroBg}
    alt="Hero Background"
    className="absolute inset-0 w-full h-full object-cover z-0"
    style={{ minHeight: '90vh', width: '100%' }}
  />
  {/* Content */}
  <div className="relative z-20 flex flex-col items-center justify-center w-full px-4 text-center">
    <h1
      className="text-3xl font-bold mb-4 drop-shadow-lg"
      style={{ fontFamily: 'Quicksand, sans-serif', color: COLORS.white }}
    >
Suffered Complications After a Transvaginal Mesh Implant?    </h1>
    <h2
      className="text-sm mb-4 font-normal drop-shadow"
      style={{ fontFamily: 'Quicksand, sans-serif', color: COLORS.white }}
    >
Thousands of women have reported chronic pain, erosion, and multiple revision surgeries after mesh implants. You may be eligible for legal compensation.    </h2>
  </div>
  {/* Overlay */}
  <div className="absolute inset-0  z-10" />
</section>

    </>
  )
}

export default TransvaginalOne
